/**
 * @param {string} url
 * @param {string} type
 */
let openDownloadLink = (url, type) => {
  let a = document.createElement('a');
  a.href = url + type;
  a.setAttribute('target', '_blank');
  a.click();
}

/**
 * @param {object} container
 * @param {string} urlDownloadSelected
 * @param {string} type
 */
let downloadSelected = (container, urlDownloadSelected, type) => {
  if( container.querySelectorAll('.dz-file-checkbox').length ) {
    const elements = container.querySelectorAll('.dz-file-checkbox')
    let selectedFiles = [];
    elements.forEach((item) => {
      if( item.checked ) {
        selectedFiles.push(item.value)
      }
    })
    if( selectedFiles.length ) {
      openDownloadLink(urlDownloadSelected, type + '?file_id=' + selectedFiles.join('|'))
    }
  }
}


/**
 * @param {object} elem
 */
let simulateClick = (elem) => {
  var evt = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  var canceled = !elem.dispatchEvent(evt);
};


/**
 * @param {object} container
 */
let deleteSelected = (container) => {
  const elements = container.querySelectorAll('.dz-file-checkbox')
  elements.forEach((item) => {
    if( item.checked ) {
      simulateClick(item.closest('.order-detail-cards__attachments-item2-wrap').querySelector('.dz-remove'))
    }
  })
}

export {
  openDownloadLink,
  downloadSelected,
  deleteSelected
}
